import PropTypes from 'prop-types';
import { Redirect, Route } from 'react-router-dom';

import { useAuth } from '../../../auth/AuthContext';

import ErrorBoundary from '../ErrorBoundry/ErrorBoundary';

import PreLoginLayout from '../../Layouts/PreLoginLayout';

const PublicRoute = ({ component: Component, ...rest }) => {
  const { user } = useAuth();

  return (
    <Route
      {...rest}
      render={({ location }) =>
        !user ? (
          <ErrorBoundary>
            <PreLoginLayout>
              <Component />
            </PreLoginLayout>
          </ErrorBoundary>
        ) : (
          <Redirect
            to={{
              pathname: '/',
              state: { from: location },
            }}
          />
        )
      }
    />
  );
};

PublicRoute.propTypes = {
  component: PropTypes.shape().isRequired,
};

export default PublicRoute;
